'use strict';

import $ from 'jquery';
import Modernizr from 'imports-loader?this=>window!exports-loader?Modernizr!./modernizr-build';
import EventEmitter from 'wolfy87-eventemitter';

export const DEVICE_TYPE_DESKTOP = 'desktop';
export const DEVICE_TYPE_TABLET = 'tablet';
export const DEVICE_TYPE_MOBILE = 'mobile';

class App extends EventEmitter {
    constructor() {
        super();

        this.timeoutTime = 150;
        this.timeoutId = null;
        this.$window = $(window);
        this.isTouch = Modernizr.touchevents;
        this.isIOSMobile = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        this.applyViewportData();

        this.$window.on('resize orientationchange', this.onWindowResize.bind(this));
    }

    applyViewportData() {
        this.viewport = {
            width: this.$window.outerWidth(),
            height: this.$window.outerHeight(),
            orientation: typeof window.orientation === "undefined" || Math.abs(window.orientation) === 90 ? "landscape" : "portrait"
        };
        this.isDesktop = Modernizr.mq('only screen and (min-width:1025px)');
        if (this.isDesktop) {
            this.isTablet = true;
        } else {
            this.isTablet = Modernizr.mq('only screen and (min-width:768px)');
        }
        this.deviceTypeByViewport = this.isDesktop ? DEVICE_TYPE_DESKTOP : (this.isTablet ? DEVICE_TYPE_TABLET : DEVICE_TYPE_MOBILE);
    }

    onWindowResize() {
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(this.handleWindowResize.bind(this), this.timeoutTime);
    }

    handleWindowResize() {
        let oldDeviceType = this.deviceTypeByViewport;
        this.applyViewportData();
        this.emitEvent('resize:finished');
        if (oldDeviceType !== this.deviceTypeByViewport) {
            this.emitEvent('device-type-changed', [oldDeviceType, this.deviceTypeByViewport]);
        }
    }

    isMobileDevice() {
        return this.deviceTypeByViewport === DEVICE_TYPE_MOBILE;
    }
}

let instance = new App();
export default instance;



// WEBPACK FOOTER //
// ./app/general/js/app-instance.js